import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface Note {
  _id?: string;
  topic_id?: string;
  user_id: string;
  title: string;
  description: string;
  color?: string;
  created_at?: string;
  updated_at?: string;
}

export interface NotesResponse {
  success?: boolean;
  message?: string;
  data?: Note[];
  topic?: Note;
}

@Injectable({
  providedIn: 'root'
})
export class NotesService {
  private apiUrl = `${environment.pythonApiUrl}/api/topics/`;

  constructor(private http: HttpClient) { }

  private getHeaders(): HttpHeaders {
    const token = localStorage.getItem('token');
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    });
  }

  // Get all notes for a user
  getNotes(userId: string): Observable<Note[]> {
    return this.http.get<Note[]>(`${this.apiUrl}?user_id=${userId}`, {
      headers: this.getHeaders()
    });
  }

  // Add a new note
  addNote(note: { user_id: string; title: string; description: string }): Observable<NotesResponse> {
    return this.http.post<NotesResponse>(this.apiUrl, note, {
      headers: this.getHeaders()
    });
  }

  // Update an existing note
  updateNote(note: { user_id: string; topic_id: string; title: string; description: string }): Observable<NotesResponse> {
    return this.http.put<NotesResponse>(this.apiUrl, note, {
      headers: this.getHeaders()
    });
  }

  // Delete a note
  deleteNote(userId: string, topicId: string): Observable<NotesResponse> {
    return this.http.request<NotesResponse>('DELETE', this.apiUrl, {
      headers: this.getHeaders(),
      body: {
        user_id: userId,
        topic_id: topicId
      }
    });
  }
}
